export default {
  common: {
    button: {
      cancel: 'Annulla',
      clear: 'Cancella',
      close: 'Chiudi',
      done: 'Fatto',
      getStarted: 'Inizia',
      next: 'Successiva',
      ok: 'OK',
      logOut: 'Esci',
      register: 'Registrati',
      reset: 'Ripristina',
      update: 'Aggiorna',
      leaveFeedback: 'Lascia un feedback',
      yes: 'Sí',
      no: 'No',
      switchUser: 'Interruttore utente'
    },
    connectivity: {
      offline: 'Offline',
      online: 'Online'
    },
    emoji: {
      bad: 'Cattivo',
      good: 'Buono',
      neutral: 'Neutro',
      perfect: 'Perfetto',
      worst: 'Peggiore'
    },
    misc: {
      copyright: '© 125 Data & Insights Ltd',
      fibLtd: '125 Data & Insights Limited',
      findOutMore: 'Scopri di più',
      licenseInfo: 'Informazioni sulla licenza',
      loading: 'Caricamento in corso',
      miles: 'Miglia',
      privacyPolicy: 'Informativa sulla privacy',
      total: 'Totale'
    },
    placeholder: {
      addYourComments: 'Aggiungi i tuoi commenti...'
    },
    social: {
      email: 'Email',
      facebook: 'Facebook',
      google: 'Google',
      tripadvisor: 'Tripadvisor',
      twitter: 'Twitter'
    },
    validation: {
      alphaNumDashes: 'Questo campo può contenere solo caratteri a-z, A-Z, trattini, trattini bassi e numeri 0-9.',
      alphaNumLower: 'Questo campo può contenere solo caratteri a-z e numeri 0-9.',
      anniversary: 'Questo campo deve contenere una data valida nel formato GG/MM',
      DDMM: 'La data deve essere formattata giorno/mese: (gg/mm)',
      DDMMYYYY: 'La data deve essere formattata giorno/mese/anno. (gg/mm/aaaa)',
      email: 'Questo campo deve contenere un indirizzo email valido',
      futureDateNotAllowed: 'La data non può essere nel futuro',
      match: 'Questo campo deve contenere un valore corrispondente',
      max: 'Questo campo non può contenere più di {n} caratteri',
      min: 'Questo campo deve contenere almeno {n} caratteri',
      numeric: 'Questo campo può contenere solo numeri 0-9',
      required: 'Obbligatorio',
      validationFailed: 'Convalida non riuscita',
      validationSuccessful: 'Convalida riuscita',
      minValue: 'Not Implemented.' // TODO: Translate (PWA)

    }
  }
};